import { colors } from "./colors";

import type { IRole } from "@/interfaces";

export const getColor = (name: IRole) => {
  return colors[name as keyof typeof colors];
};
